import { OutrightsDTO, ResultDTO, ResultFilter } from '../../interface/bets';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../types';
import { BetsAPI } from '../../apis/bets';
import { SportType } from '@supersports/services';

interface ResultState {
  result: Record<number, ResultDTO[]>;
  outrights: OutrightsDTO[];
  sports: SportType[];
  availableLeagues: string[];
  isLoading: boolean;
  filter: ResultFilter;
}

const initialState: ResultState = {} as ResultState;

export const doGetResult = createAsyncThunk('result/getAll', async (filter: ResultFilter, { getState }) => {
  const state = getState() as RootState;
  const userInfo = state.user;

  if (userInfo?.Uuid) {
    const Data = await BetsAPI.getResult(filter, userInfo);
    return Data;
  }

  return [] as ResultDTO[];
});

export const doGetOutrights = createAsyncThunk('result/getOutrights', async (filter: ResultFilter, { getState }) => {
  const state = getState() as RootState;
  const userInfo = state.user;

  if (userInfo?.Uuid) {
    const Data = await BetsAPI.getOutrights(filter, userInfo);
    return Data;
  }

  return [] as OutrightsDTO[];
});

export const resultSlice = createSlice({
  name: 'result',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(doGetResult.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(doGetOutrights.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(doGetResult.fulfilled, (state, action) => {
        const sports = action.payload?.map((item: ResultDTO) => item.SportType) ?? [];
        state.sports = Array.from(new Set(sports));

        let list: Record<number, ResultDTO[]> = [];
        const availableLeagues: string[] = [];

        action.payload?.forEach((match: ResultDTO) => {
          if (!list[match.LeagueID]) {
            list[match.LeagueID] = [];
          }

          list[match.LeagueID].push(match);

          availableLeagues.push(`${match.LeagueID}`);
        });

        if (!action?.meta?.arg?.LeagueID || action?.meta?.arg?.LeagueID === '0') {
          state.availableLeagues = availableLeagues.filter((item, index) => availableLeagues.indexOf(item) == index);
        }

        state.result = list;

        state.isLoading = false;
        state.filter = action.meta.arg;
      })
      .addCase(doGetOutrights.fulfilled, (state, action) => {
        const sports = action.payload?.map((item: OutrightsDTO) => item.SportType) ?? [];
        state.sports = Array.from(new Set(sports));

        const availableLeagues: string[] = [];

        action.payload?.forEach((match: OutrightsDTO) => {
          availableLeagues.push(`${match.LeagueID}`);
        });

        if (!action?.meta?.arg?.LeagueID || action?.meta?.arg?.LeagueID === '0') {
          state.availableLeagues = availableLeagues.filter((item, index) => availableLeagues.indexOf(item) == index);
        }

        state.outrights = action.payload;
        state.isLoading = false;
      });
  },
});

export default resultSlice.reducer;
